import * as React from "react";

export abstract class KeywordGeneratorToolPageTableAbstract<P, S> extends React.Component<P, S> {
    protected abstract tableSettings;
    protected abstract tableStorageKey;
    protected abstract dropdownAppendTo;
    protected abstract transformData;
}
